import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { TourenServiceModule } from '..';
import { TourenListComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    TourenServiceModule
  ],
  declarations: [TourenListComponent],
  exports: [TourenListComponent],

})
export class TourenListComponentModule { }
